
export default {
	name: 'ErrorSplash',
	props: {
		message: {
			required: true,
			type: String
		},
		status: {
			required: true,
			type: Number
		}
	}
}
